const initialState = null;

const newsData = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_NEWS_DATA_SUCCESS':
            return Object.assign([], state, {...action.payload} );
        case 'GET_NEWS_DATA_FAILURE':
            return Object.assign([], state, []);
        default:
            return state;
    }
};

export default newsData;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/news.js